import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"
import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"

// ACTIONS
const requested = createAction("digitalWaivers/requested")
const received = createAction("digitalWaivers/received")
const failed = createAction("digitalWaivers/failed")

const requestedWaiver = createAction("digitalWaivers/requestedWaiver")
const receivedWaiver = createAction("digitalWaivers/receivedWaiver")
const failedWaiver = createAction("digitalWaivers/failedWaiver")

// Create Waiver Actions
const createWaiverRequested = createAction("digitalWaivers/createRequested")
const createWaiverSuccess = createAction("digitalWaivers/createSuccess")
const createWaiverFailed = createAction("digitalWaivers/createFailed")

// Update Waiver Actions
const updateWaiverRequested = createAction("digitalWaivers/updateRequested")
const updateWaiverSuccess = createAction("digitalWaivers/updateSuccess")
const updateWaiverFailed = createAction("digitalWaivers/updateFailed")

// Delete Waiver Actions
const deleteWaiverRequested = createAction("digitalWaivers/deleteRequested")
const deleteWaiverSuccess = createAction("digitalWaivers/deleteSuccess")
const deleteWaiverFailed = createAction("digitalWaivers/deleteFailed")

// Post Shared Waiver Actions
const postSharedWaiverRequested = createAction("digitalWaivers/postSharedRequested")
const postSharedWaiverSuccess = createAction("digitalWaivers/postSharedSuccess")
const postSharedWaiverFailed = createAction("digitalWaivers/postSharedFailed")

// Get Shared Waiver Actions
const getSharedWaiverRequested = createAction("digitalWaivers/getSharedRequested")
const getSharedWaiverSuccess = createAction("digitalWaivers/getSharedSuccess")
const getSharedWaiverFailed = createAction("digitalWaivers/getSharedFailed")

// Delete Shared Waiver Actions
const deleteSharedWaiverRequested = createAction("digitalWaivers/deleteSharedRequested")
const deleteSharedWaiverSuccess = createAction("digitalWaivers/deleteSharedSuccess")
const deleteSharedWaiverFailed = createAction("digitalWaivers/deleteSharedFailed")

// Get Shared Waivers by Trip Booking Actions
const getSharedWaiversByTripBookingRequested = createAction("digitalWaivers/getSharedWaiversByTripBookingRequested")
const getSharedWaiversByTripBookingSuccess = createAction("digitalWaivers/getSharedWaiversByTripBookingSuccess")
const getSharedWaiversByTripBookingFailed = createAction("digitalWaivers/getSharedWaiversByTripBookingFailed")

// Post Waiver Submission Actions
const postWaiverSubmissionRequested = createAction("digitalWaivers/postSubmissionRequested")
const postWaiverSubmissionSuccess = createAction("digitalWaivers/postSubmissionSuccess")
const postWaiverSubmissionFailed = createAction("digitalWaivers/postSubmissionFailed")

// Update Waiver Submission Actions
const updateWaiverSubmissionRequested = createAction("digitalWaivers/updateSubmissionRequested")
const updateWaiverSubmissionSuccess = createAction("digitalWaivers/updateSubmissionSuccess")
const updateWaiverSubmissionFailed = createAction("digitalWaivers/updateSubmissionFailed")

// Get Waiver Submissions by Trip Booking Actions
const getWaiverSubmissionsByTripBookingRequested = createAction("digitalWaivers/getWaiverSubmissionsByTripBookingRequested")
const getWaiverSubmissionsByTripBookingSuccess = createAction("digitalWaivers/getWaiverSubmissionsByTripBookingSuccess")
const getWaiverSubmissionsByTripBookingFailed = createAction("digitalWaivers/getWaiverSubmissionsByTripBookingFailed")

// Get Signed Documents Actions
const getSignedDocumentsRequested = createAction("digitalWaivers/getSignedDocumentsRequested")
const getSignedDocumentsSuccess = createAction("digitalWaivers/getSignedDocumentsSuccess")
const getSignedDocumentsFailed = createAction("digitalWaivers/getSignedDocumentsFailed")

// Get Booking Waivers Actions
const getBookingWaiversRequested = createAction("digitalWaivers/getBookingWaiversRequested")
const getBookingWaiversSuccess = createAction("digitalWaivers/getBookingWaiversSuccess")
const getBookingWaiversFailed = createAction("digitalWaivers/getBookingWaiversFailed")

// Notify Waiver Actions
const notifyWaiverRequested = createAction("digitalWaivers/notifyWaiverRequested")
const notifyWaiverSuccess = createAction("digitalWaivers/notifyWaiverSuccess")
const notifyWaiverFailed = createAction("digitalWaivers/notifyWaiverFailed")

// Get Single Waiver Submission Actions
const getWaiverSubmissionByIdRequested = createAction("digitalWaivers/getSubmissionByIdRequested")
const getWaiverSubmissionByIdSuccess = createAction("digitalWaivers/getSubmissionByIdSuccess")
const getWaiverSubmissionByIdFailed = createAction("digitalWaivers/getSubmissionByIdFailed")

// Get Shared Waiver Notify Details Actions
const getNotifyDetailsRequested = createAction("digitalWaivers/getNotifyDetailsRequested")
const getNotifyDetailsSuccess = createAction("digitalWaivers/getNotifyDetailsSuccess")
const getNotifyDetailsFailed = createAction("digitalWaivers/getNotifyDetailsFailed")

// Check Submissions Available Actions
const checkSubmissionsRequested = createAction("digitalWaivers/checkSubmissionsRequested")
const checkSubmissionsSuccess = createAction("digitalWaivers/checkSubmissionsSuccess")
const checkSubmissionsFailed = createAction("digitalWaivers/checkSubmissionsFailed")

// REDUCER
const initialState = {
  ...LOADING_INITIAL_STATE,
  items: [],
  metadata: {
    page: null,
    total_pages: null,
    total_results: null,
    next_page: null,
    prev_page: null
  },
  sharedWaiversByTripBooking: {
    ...LOADING_INITIAL_STATE,
    items: {},
    metadata: {
      page: null,
      total_pages: null,
      total_results: null,
      next_page: null,
      prev_page: null
    },
    sharedWaiverWithoutSubmissions: {}
  },
  waiver: {
    ...LOADING_INITIAL_STATE,
    id: null,
    title: "",
    content: "",
    is_active: false,
    requires_signature: true,
    created_at: "",
    updated_at: ""
  },
  waiverSubmissionsByTripBooking: {
    ...LOADING_INITIAL_STATE,
    guest_data: [],
    share_waiver_allowed: false,
    metadata: {
      page: null,
      total_pages: null,
      total_results: null,
      next_page: null,
      prev_page: null
    },
    shared_waivers_submissions: {},
    shared_waivers_without_submissions: [],
    booking_questionnaire: {},
    incomplete_guest_waiver_submission: {},
    guest_submission: false

  },
  signedDocuments: {
    ...LOADING_INITIAL_STATE,
    items: [],
    metadata: {
      page: null,
      total_pages: null,
      total_results: null,
      next_page: null,
      prev_page: null
    }
  },
  bookingWaivers: {
    ...LOADING_INITIAL_STATE,
    items: [],
    metadata: {
      page: null,
      total_pages: null,
      total_results: null,
      next_page: null,
      prev_page: null
    }
  },
  notifyWaiver: {
    ...LOADING_INITIAL_STATE
  },
  notifyDetails: {
    ...LOADING_INITIAL_STATE,
    data: null
  },
  submissionsAvailable: {
    ...LOADING_INITIAL_STATE,
    enable_for_adult: true,
    enable_for_child: true,
    remaining_adult_count: 0,
    remaining_child_count: 0
  },
  currentWaiverSubmission: {
    ...LOADING_INITIAL_STATE,
    data: null
  },
  deleteLoading: false,
  deleteError: null,
  sharedWaivers: {
    ...LOADING_INITIAL_STATE,
    items: [],
    metadata: {
      page: null,
      total_pages: null,
      total_results: null,
      next_page: null,
      prev_page: null
    },
    deleteLoading: false,
    deleteError: null
  }
}

const digitalWaiverReducer = createReducer(initialState, {
  [requested.type]: (state) => {
    setRequested(state)
  },
  [received.type]: (state, action) => {
    setReceived(state)
    state.items = action.payload.data
    Object.assign(state.metadata, action.payload.metadata)
  },
  [failed.type]: (state) => {
    setFailed(state)
  },
  [requestedWaiver.type]: (state) => {
    setRequested(state.waiver)
  },
  [receivedWaiver.type]: (state, action) => {
    setReceived(state.waiver)
    state.waiver = action.payload
  },
  [failedWaiver.type]: (state) => {
    setFailed(state.waiver)
  },
  // Create Waiver Reducers
  [createWaiverRequested.type]: (state) => {
    state.loading = true
    state.error = null
  },
  [createWaiverSuccess.type]: (state, action) => {
    setReceived(state)
    state.items = [action.payload, ...state.items]
    state.metadata.total_results += 1
  },
  [createWaiverFailed.type]: (state, action) => {
    setFailed(state)
    state.error = action.payload
  },
  // Update Waiver Reducers
  [updateWaiverRequested.type]: (state) => {
    state.loading = true
    state.error = null
  },
  [updateWaiverSuccess.type]: (state, action) => {
    state.loading = false
    const index = state.items.findIndex((item) => item.id === action.payload.id)
    if (index !== -1) {
      state.items[index] = action.payload
    }
  },
  [updateWaiverFailed.type]: (state, action) => {
    state.loading = false
    state.error = action.payload
  },
  // Delete Waiver Reducers
  [deleteWaiverRequested.type]: (state) => {
    state.deleteLoading = true
    state.deleteError = null
  },
  [deleteWaiverSuccess.type]: (state, action) => {
    state.deleteLoading = false
    state.items = state.items.filter((item) => item.id !== action.payload)
    state.metadata.total_results = Math.max(0, state.metadata.total_results - 1)
  },
  [deleteWaiverFailed.type]: (state, action) => {
    state.deleteLoading = false
    state.deleteError = action.payload
  },
  // Post Shared Waiver Reducers
  [postSharedWaiverRequested.type]: (state) => {
    setRequested(state)
  },
  [postSharedWaiverSuccess.type]: (state) => {
    setReceived(state)
  },
  [postSharedWaiverFailed.type]: (state) => {
    setFailed(state)
  },
  // Get Shared Waiver Reducers
  [getSharedWaiverRequested.type]: (state) => {
    setRequested(state)
  },
  [getSharedWaiverSuccess.type]: (state, action) => {
    setReceived(state)
    state.waiver = action.payload
  },
  [getSharedWaiverFailed.type]: (state) => {
    setFailed(state)
  },
  // Get Shared Waivers by Trip Booking Reducers
  [getSharedWaiversByTripBookingRequested.type]: (state) => {
    setRequested(state.sharedWaiversByTripBooking)
  },
  [getSharedWaiversByTripBookingSuccess.type]: (state, action) => {
    setReceived(state.sharedWaiversByTripBooking)
    state.sharedWaiversByTripBooking.guest_submissions = action.payload.guest_submissions || action.payload
    state.sharedWaiversByTripBooking.sharedWaiverWithoutSubmissions = action.payload.shared_waiver_without_submissions || {}
    if (action.payload.metadata) {
      Object.assign(state.sharedWaiversByTripBooking.metadata, action.payload.metadata)
    }
  },
  [getSharedWaiversByTripBookingFailed.type]: (state) => {
    setFailed(state.sharedWaiversByTripBooking)
  },
  // Post Waiver Submission Reducers
  [postWaiverSubmissionRequested.type]: (state) => {
    setRequested(state)
  },
  [postWaiverSubmissionSuccess.type]: (state) => {
    setReceived(state)
  },
  [postWaiverSubmissionFailed.type]: (state) => {
    setFailed(state)
  },
  // Update Waiver Submission Reducers
  [updateWaiverSubmissionRequested.type]: (state) => {
    setRequested(state)
  },
  [updateWaiverSubmissionSuccess.type]: (state) => {
    setReceived(state)
  },
  [updateWaiverSubmissionFailed.type]: (state) => {
    setFailed(state)
  },
  // Get Waiver Submissions by Trip Booking Reducers
  [getWaiverSubmissionsByTripBookingRequested.type]: (state) => {
    setRequested(state.waiverSubmissionsByTripBooking)
  },
  [getWaiverSubmissionsByTripBookingSuccess.type]: (state, action) => {
    setReceived(state.waiverSubmissionsByTripBooking)
    state.waiverSubmissionsByTripBooking.guest_data = action.payload.guest_data
    state.waiverSubmissionsByTripBooking.shared_waivers_submissions = action.payload.shared_waivers_submissions || {}
    state.waiverSubmissionsByTripBooking.shared_waivers_without_submissions = action.payload.shared_waivers_without_submissions || {}
    state.waiverSubmissionsByTripBooking.booking_questionnaire = action.payload.booking_questionnaire || {}
    state.waiverSubmissionsByTripBooking.incomplete_guest_waiver_submission = action.payload.incomplete_guest_waiver_submission || {}
    state.waiverSubmissionsByTripBooking.guest_submission = action.payload.guest_submission
    state.waiverSubmissionsByTripBooking.share_waiver_allowed = action.payload.share_waiver_allowed
    if (action.payload.metadata) {
      Object.assign(state.waiverSubmissionsByTripBooking.metadata, action.payload.metadata)
    }
  },
  [getWaiverSubmissionsByTripBookingFailed.type]: (state) => {
    setFailed(state.waiverSubmissionsByTripBooking)
  },
  // Get Signed Documents Reducers
  [getSignedDocumentsRequested.type]: (state) => {
    setRequested(state.signedDocuments)
  },
  [getSignedDocumentsSuccess.type]: (state, action) => {
    setReceived(state.signedDocuments)
    state.signedDocuments.items = action.payload.data || []
    state.signedDocuments.metadata = {
      ...state.signedDocuments.metadata,
      ...action.payload.metadata
    }
  },
  [getSignedDocumentsFailed.type]: (state) => {
    setFailed(state.signedDocuments)
  },
  // Get Booking Waivers Reducers
  [getBookingWaiversRequested.type]: (state) => {
    setRequested(state.bookingWaivers)
  },
  [getBookingWaiversSuccess.type]: (state, action) => {
    setReceived(state.bookingWaivers)
    state.bookingWaivers.items = action.payload.data || []
    state.bookingWaivers.metadata = {
      ...state.bookingWaivers.metadata,
      ...action.payload.metadata
    }
  },
  [getBookingWaiversFailed.type]: (state) => {
    setFailed(state.bookingWaivers)
  },
  // Notify Waiver Reducers
  [notifyWaiverRequested.type]: (state) => {
    setRequested(state.notifyWaiver)
  },
  [notifyWaiverSuccess.type]: (state) => {
    setReceived(state.notifyWaiver)
  },
  [notifyWaiverFailed.type]: (state) => {
    setFailed(state.notifyWaiver)
  },
  // Get Single Waiver Submission Reducers
  [getWaiverSubmissionByIdRequested.type]: (state) => {
    setRequested(state.currentWaiverSubmission)
    state.currentWaiverSubmission.data = null
  },
  [getWaiverSubmissionByIdSuccess.type]: (state, action) => {
    setReceived(state.currentWaiverSubmission)
    state.currentWaiverSubmission.data = action.payload
  },
  [getWaiverSubmissionByIdFailed.type]: (state) => {
    setFailed(state.currentWaiverSubmission)
  },
  // Get Notify Details Reducers
  [getNotifyDetailsRequested.type]: (state) => {
    setRequested(state.notifyDetails)
    state.notifyDetails.data = null
  },
  [getNotifyDetailsSuccess.type]: (state, action) => {
    setReceived(state.notifyDetails)
    state.notifyDetails.data = action.payload
  },
  [getNotifyDetailsFailed.type]: (state) => {
    setFailed(state.notifyDetails)
  },
  // Check Submissions Available Reducers
  [checkSubmissionsRequested.type]: (state) => {
    setRequested(state.submissionsAvailable)
  },
  [checkSubmissionsSuccess.type]: (state, action) => {
    setReceived(state.submissionsAvailable)
    state.submissionsAvailable.enable_for_adult = action.payload?.enable_for_adult ?? true
    state.submissionsAvailable.enable_for_child = action.payload?.enable_for_child ?? true
    state.submissionsAvailable.remaining_adult_count = action.payload?.remaining_adult_count ?? 0
    state.submissionsAvailable.remaining_child_count = action.payload?.remaining_child_count ?? 0
  },
  [checkSubmissionsFailed.type]: (state) => {
    setFailed(state.submissionsAvailable)
  },
  // Delete Shared Waiver Reducers
  [deleteSharedWaiverRequested.type]: (state) => {
    setRequested(state.sharedWaivers)
    state.sharedWaivers.deleteError = null
  },
  [deleteSharedWaiverSuccess.type]: (state, action) => {
    setReceived(state.sharedWaivers)
    state.sharedWaivers.items = state.sharedWaivers.items.filter((item) => item.id !== action.payload)
    state.sharedWaivers.metadata.total_results = Math.max(0, state.sharedWaivers.metadata.total_results - 1)
  },
  [deleteSharedWaiverFailed.type]: (state, action) => {
    state.sharedWaivers.deleteLoading = false
    state.sharedWaivers.deleteError = action.payload
  }
})

// ACTION CREATORS

/**
 * Fetches paginated list of digital waivers for guide
 * @param {number} page - Page number to fetch
 * @param {number} pageSize - Number of items per page
 * @param {string} status - Status filter
 * @param {string} search - Search query
 * @param {boolean|null} isActive - Filter by active status (true/false), null to ignore
 * @returns {Object} - API action object
 */
export const getGuideDigitalWaivers = (page = 1, pageSize = 10, status = "", search = "", isActive = null, sort = "", order = "") => {
  const params = {
    page,
    per_page: pageSize,
    ...(status && { status }),
    ...(search && { search: search.trim() }),
    ...(isActive !== null && { is_active: isActive }),
    ...(sort && order ? { [`sort[${sort}]`]: order } : {})
  }
  return api({
    url: "/guide/digital_waivers",
    method: "get",
    params,
    onStart: requested.type,
    onSuccess: received.type,
    onError: failed.type
  })
}

// Create a new digital waiver
export const createDigitalWaiver = (waiverData) => {
  return api({
    url: "/guide/digital_waivers",
    method: "post",
    data: waiverData,
    onStart: createWaiverRequested.type,
    onSuccess: createWaiverSuccess.type,
    onError: createWaiverFailed.type
  })
}

// Update an existing digital waiver
export const updateDigitalWaiver = (id, waiverData) => {
  return api({
    url: `/guide/digital_waivers/${id}`,
    method: "put",
    data: waiverData,
    onStart: updateWaiverRequested.type,
    onSuccess: updateWaiverSuccess.type,
    onError: updateWaiverFailed.type
  })
}

// Delete a digital waiver
export const deleteDigitalWaiver = (id) => {
  return api({
    url: `/guide/digital_waivers/${id}`,
    method: "delete",
    onStart: deleteWaiverRequested.type,
    onSuccess: deleteWaiverSuccess.type,
    onError: deleteWaiverFailed.type
  })
}

// Update a digital waiver
export const updateDigitalWaiverStatus = (id, isActive) => {
  return api({
    url: `/guide/digital_waivers/${id}/update_status`,
    method: "patch",
    data: isActive,
    onStart: updateWaiverRequested.type,
    onSuccess: updateWaiverSuccess.type,
    onError: updateWaiverFailed.type
  })
}

// Post shared waiver from client
export const postSharedWaiver = (waiverData) => {
  return api({
    url: "/client/shared_waivers",
    method: "post",
    data: waiverData,
    onStart: postSharedWaiverRequested.type,
    onSuccess: postSharedWaiverSuccess.type,
    onError: postSharedWaiverFailed.type
  })
}

// Get shared waiver by ID
export const getSharedWaiver = (id) => {
  return api({
    url: `/client/shared_waivers/${id}`,
    method: "get",
    onStart: getSharedWaiverRequested.type,
    onSuccess: getSharedWaiverSuccess.type,
    onError: getSharedWaiverFailed.type
  })
}

// Get shared waivers by trip booking ID
export const getSharedWaiversByTripBooking = (tripBookingId) => {
  return api({
    url: "/client/shared_waivers",
    method: "get",
    params: { trip_booking_id: tripBookingId },
    onStart: getSharedWaiversByTripBookingRequested.type,
    onSuccess: getSharedWaiversByTripBookingSuccess.type,
    onError: getSharedWaiversByTripBookingFailed.type
  })
}

// Post waiver submission
export const postWaiverSubmission = (submissionData) => {
  return api({
    url: "/client/waiver_submissions",
    method: "post",
    data: submissionData,
    onStart: postWaiverSubmissionRequested.type,
    onSuccess: postWaiverSubmissionSuccess.type,
    onError: postWaiverSubmissionFailed.type
  })
}

// Update waiver submission by ID
export const updateWaiverSubmission = (id, submissionData) => {
  return api({
    url: `/client/waiver_submissions/${id}`,
    method: "put",
    data: submissionData,
    onStart: updateWaiverSubmissionRequested.type,
    onSuccess: updateWaiverSubmissionSuccess.type,
    onError: updateWaiverSubmissionFailed.type
  })
}

export const saveWaiverAsDraft = (id) => {
  return api({
    url: `/client/waiver_submissions/${id}/save_as_draft`,
    method: "put"
  })
}

// Get single waiver submission by ID
export const getWaiverSubmissionById = (id) => {
  return api({
    url: `/client/waiver_submissions/${id}`,
    method: "get",
    onStart: getWaiverSubmissionByIdRequested.type,
    onSuccess: getWaiverSubmissionByIdSuccess.type,
    onError: getWaiverSubmissionByIdFailed.type
  })
}

// Get waiver submissions by trip booking UUID
export const getWaiverSubmissionsByTripBooking = (uuid, guestToken) => {
  return api({
    url: `/trip_bookings/${uuid}/waiver_submissions`,
    method: "get",
    ...(guestToken ? { guestToken } : {}),
    onStart: getWaiverSubmissionsByTripBookingRequested.type,
    onSuccess: getWaiverSubmissionsByTripBookingSuccess.type,
    onError: getWaiverSubmissionsByTripBookingFailed.type
  })
}

// Get signed documents
export const getSignedDocuments = (guideId, page = 1, pageSize = 10, search = "", experienceIds = null, sort = "", order = "") => {
  const params = {
    page,
    per_page: pageSize,
    ...(search && { search: search.trim() }),
    ...(experienceIds && experienceIds.length > 0 && { experience_ids: `[${experienceIds.join(',')}]` }),
    ...(sort && order ? { [`sort[${sort}]`]: order } : {})
  }
  return api({
    url: `/guides/${guideId}/signed_documents`,
    method: "get",
    params,
    onStart: getSignedDocumentsRequested.type,
    onSuccess: getSignedDocumentsSuccess.type,
    onError: getSignedDocumentsFailed.type
  })
}

// Get booking waivers by trip booking UUID
export const getBookingWaivers = (uuid, sortParams = {}) => {
  const params = {}
  
  // Add sorting parameters if provided
  Object.keys(sortParams).forEach(key => {
    if (sortParams[key]) {
      params[`sort[${key}]`] = sortParams[key]
    }
  })
  
  return api({
    url: `/trip_bookings/${uuid}/booking_waivers`,
    method: "get",
    params,
    onStart: getBookingWaiversRequested.type,
    onSuccess: getBookingWaiversSuccess.type,
    onError: getBookingWaiversFailed.type
  })
}

// Notify waiver by trip booking UUID
export const notifyWaiver = (uuid, data) => {
  return api({
    url: `/trip_bookings/${uuid}/sign_waiver_notification`,
    method: "post",
    data:data ,
    onStart: notifyWaiverRequested.type,
    onSuccess: notifyWaiverSuccess.type,
    onError: notifyWaiverFailed.type
  })
}

// Delete shared waiver by ID
export const deleteSharedWaiver = (id) => {
  return api({
    url: `/client/shared_waivers/${id}`,
    method: "delete",
    onStart: deleteSharedWaiverRequested.type,
    onSuccess: deleteSharedWaiverSuccess.type,
    onError: deleteSharedWaiverFailed.type
  })
}

// Get shared waiver notify details
export const getSharedWaiverNotifyDetails = (sharedWaiverId) => {
  return api({
    url: `/client/shared_waivers/${sharedWaiverId}/notify_details`,
    method: "get",
    onStart: getNotifyDetailsRequested.type,
    onSuccess: getNotifyDetailsSuccess.type,
    onError: getNotifyDetailsFailed.type
  })
}

// Check submissions available
export const checkSubmissionsAvailable = (uuid) => {
  return api({
    url: `/trip_bookings/${uuid}/check_submissions_available`,
    method: "get",
    onStart: checkSubmissionsRequested.type,
    onSuccess: checkSubmissionsSuccess.type,
    onError: checkSubmissionsFailed.type
  })
}

export default digitalWaiverReducer
